import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BodyM, HeadlineM } from '#src/atoms/typography/index.tsx';

const Root = styled(Vertical).attrs({ gap: 3 })`
  padding: var(--triple-unit);
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
`;

type Props = {
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
};

export const OffRampStepLayout = ({ title, description, children }: Props) => (
  <Root>
    <Vertical gap={1}>
      <HeadlineM as="h1">{title}</HeadlineM>
      {!!description && <BodyM color="var(--c-nd-600)">{description}</BodyM>}
    </Vertical>
    {children}
  </Root>
);
